/* eslint-disable react/jsx-no-target-blank */
import { useIntl } from 'react-intl'
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub'
import { AsideMenuItem } from './AsideMenuItem'
import { useMenuCountStore } from '../../../../app/core/state-management/states/menuCount';
import { apiCaller } from '../../../../app/core/hooks/useApi';
import { ServiceAgent } from '../../../../app/core/services/serviceAgent';
import { useEffect } from 'react';
import { useWroteStore } from '../../../../app/core/state-management/states/wrote';
import { useCardtableStore } from '../../../../app/core/state-management/states/cardtable/index2';
import { useAuth } from '../../../../app/modules/auth';
import { CLAIMS } from '../../../../app/core/constants/claims';
import { useSupervisionMenuCountStore } from '../../../../app/core/state-management/states/supervisionMenuCount';

export function AsideMenuMain() {
  const intl = useIntl();

  const { userInfo } = useAuth();

  const { dispatch, state } = useMenuCountStore();
  const { dispatch: dispatchSupervisionMenuCount, state: steteSupervisionMenuCount } = useSupervisionMenuCountStore();

  const { state: worteState } = useWroteStore();
  const { state: cardtableState } = useCardtableStore();

  ///states
  const { menuCountInfo } = state;
  const { menuCountInfo: supervisionMenuCountInfo } = steteSupervisionMenuCount;

  const { WroteList } = worteState
  const { CardTableList, RequestData } = cardtableState;

  ////handler
  const getMenuCountData = () => {
    apiCaller({
      api: ServiceAgent.cardtable.request_getmenucount,
      onSuccess(resp) {
        if (resp?.status === 200 && resp?.data?.statusCode === 200) {
          dispatch({
            payload: { menuCountInfo: resp?.data?.data },
            type: 'SET_MENUCOUNT_DATA'
          })
        }
      },
    })
  }

  const getSupervisionMenuCountData = () => {
    apiCaller({
      api: ServiceAgent.supervision.request_getmenucount,
      onSuccess(resp) {
        if (resp?.status === 200 && resp?.data?.statusCode === 200) {
          dispatchSupervisionMenuCount({
            payload: { menuCountInfo: resp?.data?.data },
            type: 'SET_MENUCOUNT_DATA'
          })
        }
      },
    })
  }

  const getNotifications = () => {
    apiCaller({
      api: ServiceAgent.notifications.request_getAll,
      apiArguments: {
        CurrentPage: 1,
        PageSize: 5,
      },
      onSuccess(resp) {
        if (resp?.status === 200 && resp?.data?.statusCode === 200) {
          dispatch({
            payload: { allNotifications: resp?.data?.data?.data },
            type: 'SET_NOTIFICATION_DATA'
          })
        }
      },
    })
  }

  useEffect(() => {
    getMenuCountData()
    getNotifications()
    getSupervisionMenuCountData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [WroteList, CardTableList, RequestData])

  // ─── Claims ────────────────────────────────────────────────────────────
  const userClaims = userInfo?.userClaims?.map((x: any) => x.claimValue) || []
  const hasClaims = userClaims.length > 0

  /**
   * بررسی دسترسی:
   *  - exact match: "Cartable.Guarantee"
   *  - prefix match: "Cartable" → "Cartable.Guarantee"
   */
  const matches = (p: string) =>
    userClaims.includes(p) || userClaims.some((c) => c.startsWith(p + '.'))

  const can = (p?: string) => {
    if (!hasClaims) return true
    if (!p) return true
    return matches(p)
  }

  /** آیا کاربر حداقل به یکی از claimهای داده‌شده دسترسی دارد؟ */
  const hasAny = (claims: readonly string[]) =>
    !hasClaims || claims.some(matches)

  return (
    <>
      {/* DASHBOARD */}
      {can(CLAIMS.Dashboard) && (
        <AsideMenuItem
          to='/dashboard'
          icon='element-11'
          title={intl.formatMessage({ id: 'MENU.DASHBOARD' })}
        />
      )}

      {/* CARTABLE */}
      {hasAny([
        CLAIMS.Cartable.CreditLineFacilities,
        CLAIMS.Cartable.InternalResourcesFacilities,
        CLAIMS.Cartable.Guarantee,
        CLAIMS.Cartable.BrokerageFacilities,
        CLAIMS.Cartable.Investment,
        CLAIMS.Cartable.AllCartables,
        CLAIMS.Cartable.WaitingList,
        CLAIMS.Cartable.Archive,
      ]) && (
        <AsideMenuItemWithSub to='/cardboard' title='کارتابل' icon='document'>
          {can(CLAIMS.Cartable.CreditLineFacilities) && (
            <AsideMenuItem to='/getall-cardtable-list/1' title={`تسهیلات خط اعتباری ${menuCountInfo?.khatEtebari || '0'}`} hasBullet />
          )}
          {can(CLAIMS.Cartable.InternalResourcesFacilities) && (
            <AsideMenuItem to='/getall-cardtable-list/2' title={`تسهیلات منابع داخلی ${menuCountInfo?.manabeDakheli || '0'}`} hasBullet />
          )}
          {can(CLAIMS.Cartable.Guarantee) && (
            <AsideMenuItem to='/getall-cardtable-list/3' title={`ضمانت نامه ${menuCountInfo?.zemanatName || '0'}`} hasBullet />
          )}
          {can(CLAIMS.Cartable.BrokerageFacilities) && (
            <AsideMenuItem to='/getall-cardtable-list/4' title={`تسهیلات کارگزاری ${menuCountInfo?.karqozari || '0'}`} hasBullet />
          )}
          {can(CLAIMS.Cartable.Investment) && (
            <AsideMenuItem to='/getall-cardtable-list/5' title={`سرمایه گذاری خطر پذیر ${menuCountInfo?.khatarpazir || '0'}`} hasBullet />
          )}
          {can(CLAIMS.Cartable.AllCartables) && (
            <AsideMenuItem to='/getall-cardtable-list/6' title={`همه کارتابل ها ${menuCountInfo?.allCardBoard || '0'}`} hasBullet />
          )}
          {can(CLAIMS.Cartable.WaitingList) && (
            <AsideMenuItem to='/cardtable-waiting-list' title={`لیست انتظار ${menuCountInfo?.weitingList || '0'}`} hasBullet />
          )}
          {can(CLAIMS.Cartable.Archive) && (
            <AsideMenuItem to='/cardtable-archive-list' title={`بایگانی ${menuCountInfo?.archiveBox || '0'}`} hasBullet />
          )}
        </AsideMenuItemWithSub>
      )}

      {/* SUPERVISION */}
      {hasAny([
        CLAIMS.Supervision.CreditLineFacilities,
        CLAIMS.Supervision.InternalResourcesFacilities,
        CLAIMS.Supervision.Guarantee,
        CLAIMS.Supervision.BrokerageFacilities,
        CLAIMS.Supervision.Investment,
        CLAIMS.Supervision.All,
      ]) && (
        <AsideMenuItemWithSub to='/supervision' title='بخش نظارت' icon='eye'>
          {can(CLAIMS.Supervision.CreditLineFacilities) && (
            <AsideMenuItem to='/getall-supervision-list/1' title={`تسهیلات خط اعتباری ${supervisionMenuCountInfo?.khatEtebari || '0'}`} hasBullet />
          )}
          {can(CLAIMS.Supervision.InternalResourcesFacilities) && (
            <AsideMenuItem to='/getall-supervision-list/2' title={`تسهیلات منابع داخلی ${supervisionMenuCountInfo?.manabeDakheli || '0'}`} hasBullet />
          )}
          {can(CLAIMS.Supervision.Guarantee) && (
            <AsideMenuItem to='/getall-supervision-list/3' title={`ضمانت نامه ${supervisionMenuCountInfo?.zemanatName || '0'}`} hasBullet />
          )}
          {can(CLAIMS.Supervision.BrokerageFacilities) && (
            <AsideMenuItem to='/getall-supervision-list/4' title={`تسهیلات کارگزاری ${supervisionMenuCountInfo?.karqozari || '0'}`} hasBullet />
          )}
          {can(CLAIMS.Supervision.Investment) && (
            <AsideMenuItem to='/getall-supervision-list/5' title={`سرمایه گذاری ${supervisionMenuCountInfo?.khatarpazir || '0'}`} hasBullet />
          )}
          {can(CLAIMS.Supervision.All) && (
            <AsideMenuItem to='/getall-supervision-list/6' title={`همه ${supervisionMenuCountInfo?.allCardBoard || '0'}`} hasBullet />
          )}
        </AsideMenuItemWithSub>
      )}

      {/* AUTOMATION */}
      {can(CLAIMS.Automation.View) && (
        <AsideMenuItemWithSub to='/management-letter' title='اتوماسیون' icon='update-file'>
          <AsideMenuItem to='/management-letter' title={`مدیریت اتوماسیون ${menuCountInfo?.myLetter || '0'}`} hasBullet />
        </AsideMenuItemWithSub>
      )}

      {/* TRANSCRIPT */}
      {can(CLAIMS.Transcript.All) && (
        <AsideMenuItemWithSub to='/reminder' title='رونوشت ها' icon='notepad-bookmark'>
          <AsideMenuItem to='/wrote' title={`همه رونوشت ها ${menuCountInfo?.transcript || '0'}`} hasBullet />
        </AsideMenuItemWithSub>
      )}

      {/* REQUESTS */}
      {hasAny([
        CLAIMS.Request.InProgress,
        CLAIMS.Request.Completed,
        CLAIMS.Request.Returned,
      ]) && (
        <AsideMenuItemWithSub to='/request' title='لیست همه درخواست ها' icon='update-file'>
          {can(CLAIMS.Request.InProgress) && (
            <AsideMenuItem to='/all-request/1' title='در جریان' hasBullet />
          )}
          {can(CLAIMS.Request.Completed) && (
            <AsideMenuItem to='/all-request/2' title='تکمیل شده' hasBullet />
          )}
          {can(CLAIMS.Request.Returned) && (
            <AsideMenuItem to='/all-request/3' title='عودت داده شده' hasBullet />
          )}
        </AsideMenuItemWithSub>
      )}

      {/* LETTERS */}
      {can(CLAIMS.Letter.All) && (
        <AsideMenuItem to='/letter' icon='message-question' title='لیست تمامی نامه ها' />
      )}

      {/* PERSONNEL */}
      {can(CLAIMS.Personnel.View) && (
        <AsideMenuItemWithSub to='/personel' title='پرسنل' icon='profile-circle'>
          <AsideMenuItem to='/personel-list' title='مدیریت پرسنل' hasBullet />
        </AsideMenuItemWithSub>
      )}

      {/* Q&A / SURVEY */}
      {can(CLAIMS.Survey.View) && (
        <AsideMenuItemWithSub to='/survey' title='پرسش و پاسخ' icon='question'>
          <AsideMenuItem to='/survey-category' title='ایجاد برگه نظرسنجی' hasBullet />
        </AsideMenuItemWithSub>
      )}

      {/* FINANCE */}
      {can(CLAIMS.Finance.AllTransactions) && (
        <AsideMenuItemWithSub to='/finance' title='مالی' icon='wallet'>
          <AsideMenuItem to='/all-transaction' title='همه تراکنش ها' hasBullet />
        </AsideMenuItemWithSub>
      )}

      {/* SUPPORT */}
      {can(CLAIMS.Support) && (
        <AsideMenuItem to='/tickets' icon='user' title='پشتیبانی' />
      )}

      {/* SUGGESTED TEXTS */}
      {can(CLAIMS.SuggestedTexts) && (
        <AsideMenuItem to='/custom-text' icon='text' title='متن های پیشنهادی' />
      )}

      {/* LETTER ARCHIVE */}
      {can(CLAIMS.LetterArchive) && (
        <AsideMenuItem to='/archived-document' icon='paper-clip' title='بایگانی نامه' />
      )}

      {/* SUBSCRIPTION */}
      {can(CLAIMS.SubscriptionManagement) && (
        <AsideMenuItem to='/plans' icon='dollar' title='مدیریت اشتراک ها' />
      )}

      {/* REQUEST FORM */}
      {can(CLAIMS.RequestForm) && (
        <AsideMenuItem to='/request-form' icon='send' title='فرم درخواست' />
      )}

      {/* TRAINING */}
      {can(CLAIMS.TrainingVideos) && (
        <AsideMenuItem to='/support-video' icon='google-play' title='ویدئو های آموزشی' />
      )}

      {/* REPORTS */}
      {can(CLAIMS.Reports) && (
        <AsideMenuItem to='/reports-navigate' icon='chart' title='گزارشات' />
      )}

      {/* FAQ */}
      {can(CLAIMS.FAQ) && (
        <AsideMenuItem to='/faq' icon='questionnaire-tablet' title='سوالات متداول' />
      )}

      {/* USERS */}
      {can(CLAIMS.Users) && (
        <AsideMenuItem to='/user-list' icon='user-tick' title='لیست کاربران' />
      )}

      {/* SETTINGS */}
      {can(CLAIMS.Settings.CRM) && (
        <AsideMenuItemWithSub to='/setting' title='تنظیمات' icon='setting-2'>
          <AsideMenuItem to='/setting-managment' title='تنظیمات CRM' />
        </AsideMenuItemWithSub>
      )}
    </>
  )
}